import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import FormVendorField from '../../../FormFields/FormVendorField';
import FormTitle from '../../../FormFields/FormTitle';
import { CLINICAL } from '../../../formQuestionsEnum';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { formCardStyle } from '../../../TransitionStyles';

ClinicalVendorsForm.propTypes = {
  permissions: PropTypes.object,
};

export default function ClinicalVendorsForm({ permissions }) {
  const showForm = [
    CLINICAL.PHARMACY_VENDOR,
    CLINICAL.PHARMACY_CONSULTANT_VENDOR,
    CLINICAL.EDUCATION_VENDOR,
    CLINICAL.MDS_SCRUBBER,
  ].some(({ id }) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Clinical Vendors
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL.PHARMACY_VENDOR.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Pharmacy', fieldType: 'title' }} />
              <FormVendorField
                fieldName={CLINICAL.PHARMACY_VENDOR.fieldName}
                fieldAttributes={{ isEditable: permissions[CLINICAL.PHARMACY_VENDOR.id] }}
                invoiceFileTypeId={FILE_TYPES.PHARMACY_VENDOR_INVOICE}
                contractFileTypeId={FILE_TYPES.PHARMACY_VENDOR_CONTRACT}
              />
            </Grid>
          )}
          {CLINICAL.PHARMACY_CONSULTANT_VENDOR.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Pharmacy consultant', fieldType: 'title' }} />
              <FormVendorField
                fieldName={CLINICAL.PHARMACY_CONSULTANT_VENDOR.fieldName}
                fieldAttributes={{ isEditable: permissions[CLINICAL.PHARMACY_CONSULTANT_VENDOR.id] }}
                invoiceFileTypeId={FILE_TYPES.PHARMACY_CONSULTANT_VENDOR_INVOICE}
                contractFileTypeId={FILE_TYPES.PHARMACY_CONSULTANT_VENDOR_CONTRACT}
              />
            </Grid>
          )}
          {CLINICAL.EDUCATION_VENDOR.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Education', fieldType: 'title' }} />
              <FormVendorField
                fieldName={CLINICAL.EDUCATION_VENDOR.fieldName}
                fieldAttributes={{ isEditable: permissions[CLINICAL.EDUCATION_VENDOR.id] }}
                invoiceFileTypeId={FILE_TYPES.EDUCATION_VENDOR_INVOICE}
                contractFileTypeId={FILE_TYPES.EDUCATION_VENDOR_CONTRACT}
              />
            </Grid>
          )}
          {CLINICAL.MDS_SCRUBBER.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'MDS scrubber', fieldType: 'title' }} />
              <FormVendorField
                fieldName={CLINICAL.MDS_SCRUBBER.fieldName}
                fieldAttributes={{ isEditable: permissions[CLINICAL.MDS_SCRUBBER.id] }}
                invoiceFileTypeId={FILE_TYPES.MDS_SCRUBBER_VENDOR_INVOICE}
                contractFileTypeId={FILE_TYPES.MDS_SCRUBBER_VENDOR_CONTRACT}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
